import React, { memo } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

type PlantNameSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
};

const PlantNameSearchInput: React.FC<PlantNameSearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search name",
  autoFocus = true,
}) => (
  <Box sx={{ px: 2, pt: 2, pb: 1 }}>
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      autoFocus={autoFocus}
      InputProps={{
        sx: {
          borderRadius: 999,
          bgcolor: "#fff",
          fontSize: 15,
          "& fieldset": { borderColor: "#d0d0d0" },
        },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: "#9e9e9e", fontSize: 22 }} />
          </InputAdornment>
        ),
      }}
    />
  </Box>
);

export default memo(PlantNameSearchInput);
